export default {
    en: {
        id: 'diagram4b2-2',
        blocks: [
            {
                index: '1',
                task: 'S = Easier than before to build a product and start a company',
                title: "S = "
            },
            {
                index: '2',
                task: 'C = Making the company a success is less easy – most new businesses fail',
                title: "C = "
            },
            {
                index: '3',
                task: 'Q = Why do so many people gamble on ventures that are likely to end badly?',
                title: "Q = "
            }
        ],
        answers: [
            {
                index: '1',
                title: 'Hundreds starting X'
            },
            {
                index: '3',
                title: 'Why do a start-up?'
            },
            {
                index: '2',
                title: 'Most fail'
            },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3,
        note: 'Trying to answer Why? as a question leading to the top point is a real trap you should try to avoid.  Although it make sense here as part of the story, the author is not writing to explain why they do it.  He will likely  have investigated, analyzed, and summarized the reasons why, as a basis for drawing a conclusion about how they justify it to themselves.  So the question is really something like “How do they justify it to themselves”, and the answer would be something like “They convince themselves it will not happen to them”.  The reader’s question is then how, and the document is structured around the ways they convince themselves.  You would never simply list the reasons for an occurrence without stating the insight into motivation behind it - and possibilities for behavioral change -  you can draw from them'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise2.js